import React from "react"
import ReactTooltip from "react-tooltip"

let tooltipCounter = 0

interface FormulaTagProps {
	formula: string
	maxWidth?: string
	className?: string
}

export default function FormulaTag({formula, maxWidth, className}: FormulaTagProps) {
	const tooltipId = maxWidth ? `formula-tag-tooltip-${++tooltipCounter}` : undefined

	return (
		<>
			<div
				className={`interest-formula-box-container${maxWidth ? " truncated" : ""}${className ? ` ${className}` : ""}`}
				style={maxWidth ? {maxWidth} : undefined}
				data-tip={maxWidth ? true : undefined}
				data-for={tooltipId}
			>
				<span className="formula-text">{formula}</span>
			</div>
			{maxWidth && tooltipId && (
				<ReactTooltip id={tooltipId} effect="solid" place="top" className="formula-tag-hover-tooltip">
					<span>{formula}</span>
				</ReactTooltip>
			)}
		</>
	)
}
